<template>
  <div class="title">
    <h4>{{ title }}</h4>
    <img @click.prevent
         :src="BORDER">
    <div class="title-p"
         :class="{'title-p_center': desAlign === 'center'}"
         v-if="des"
         v-html="des">
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  props: {
    title: {
      type: String,
      default: ''
    },
    des: {
      type: String,
      default: ''
    },
    desAlign: {
      type: String,
      default: 'left' // left, center
    }
  },
  data () {
    return {
      BORDER: require('images/brand/border.png')
    }
  },
  components: {},
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {}
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.title {
  h4 {
    font-size: px2rem(15);
    color: #3c3c3c;
    font-weight: bold;
    text-align: center;
  }
  img {
    display: block;
    margin: px2rem(8) auto 0;
    width: px2rem(189);
  }
  &-p {
    color: #666666;
    font-size: px2rem(13);
    line-height: px2rem(20);
    padding: px2rem(12) px2rem(30) 0;
  }
  &-p_center {
    text-align: center;
  }
}
</style>
